export default function Rust_Enums() {
  return (
    <div>
      <h1>Rust_Enums Component</h1>
      <p>This is the Rust_Enums page.</p>
    </div>
  );
}
